import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonSlide, IonFooter } from '@ionic/react';

import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../../css/qavaApp.css';

export function DeleteEmployeeModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [globalEmployeeID, setGlobalEmployeeID] = useState(null);
    let [viewEmployeeDetailsData, setViewEmployeeDetailsData] = useState([]);
    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);
    let [employeeManagementAccessCheckboxValue, setEmployeeManagementAccessCheckboxValue] = useState(null);
    let [checkInCheckOutAccessCheckboxValue, setCheckInCheckOutAccessCheckboxValue] = useState(null);
    let [cleaningServicesAccessCheckboxValue, setCleaningServicesAccessCheckboxValue] = useState(null);
    let [employeeID, setEmployeeID] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false)
    let [enteredPassword, setEnteredPassword] = useState('');

    let employeeNameRef = useRef('');
    let enterPasswordRef = useRef('');


    function deleteEmployee(event)
    {
        setShowPasswordModal(false);

        /*
        let formData = new FormData();
        formData.append('Tracker', 74599);
        formData.append('user', acctID);
        formData.append('xGlobalEmployeeID', globalEmployeeID);
        formData.append('xEmployeeID', employeeID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74599',
                user: acctID,
                xGlobalEmployeeID: event[0],
                xEmployeeID: event[1],
                xEnterAdminPassword: enterPasswordRef.current.value,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function searchEmployeeList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchEmployeeInDB(searchCategory, searchData);


    }

    function first_searchEmployeeInDB(searchCategory, searchData, optionsData)
    {
        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {

            Tracker = '74502';
        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSearchEmployee: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);
                    
                                    setViewEmployeeDetailsData((prevViewEmployeeDetailsData) => {
                                        return prevViewEmployeeDetailsData.concat({
                                            globalEmployeeID: cols[0],
                                            employeeID: cols[1],
                                            employeeFirstName: cols[2],
                                            employeeLastName: cols[3],
                                            dateHired: cols[4],
                                            biWeeklyPay: cols[5],
                                            jobFunction: cols[6],
                                            phoneNumber: cols[7],
                                            emailAddress: cols[8],
                                            employeeSchema: cols[9],
                                            inventoryAccess: cols[10],
                                            managementAccess: cols[11],
                                            checkInCheckOutAccess: cols[12],
                                            cleaningServicesAccess: cols[13],

                                        })
                                    });
                    
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }

                                if(cols[10] === 'y')
                                {
                                    document.getElementById('inventoryAccess').checked = true;
                                }
                                if(cols[11] === 'y')
                                {
                                    document.getElementById('employeeManagementAccess').checked = true;
                                }
                                if(cols[12] === 'y')
                                {
                                    document.getElementById('checkInCheckOutAccess').checked = true;
                                }        
                                if(cols[13] === 'y')
                                {
                                    document.getElementById('cleaningServicesAccess').checked = true;
                                }
                            }
                    })
    }

    

    function onSubmitPasswordHandler(event) 
    {
        alert('in onsubmitPassword handler');
        alert(event);

        deleteEmployee(event);
    }

    function openPasswordModal(event)
    {

        alert('in openPasswordModal handler');
        alert(event);
        alert(event[0]);
        alert(event[1]);
        
        setShowPasswordModal(true);
        setGlobalEmployeeID(event[0]);
        setEmployeeID(event[1]);
    }

    let timeout;

    function handleInput(event) {

        setViewEmployeeDetailsData([]);

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchEmployeeList(event), 2000); // Set a new timeout
    
    }

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
                <IonHeader style={{color: "black"}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <IonText>DELETE EMPLOYEE</IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
                <IonContent className='grid_content'>

                <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <h4>Search Employees:</h4>
                            </IonCol>
                            <IonCol size='12'>
                                <input type='text' id='searchEmployee' ref={ employeeNameRef } placeholder='Search Employee name' onInput={() => handleInput(['name', employeeNameRef.current.value])} list='searchEmployeeNameList' autocomplete='off' required></input>
                                <datalist id='searchEmployeeNameList'>
                                    {viewEmployeeDetailsData.map((result) => (
                                        <option key={result.employeeID} value={result.employeeFirstName}></option>
                                    ))}
                                </datalist>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                    <div className='deleteEmployeeGrid' style={{display: 'inline-block'}}>
                    <IonGrid>
                        <IonRow>
                                <IonCol >Employee ID</IonCol>
                                <IonCol >Employee Name</IonCol>
                               <IonCol >Date Hired</IonCol>
                                 {/*<IonCol >Bi-weekly Pay</IonCol>
                                <IonCol >Job Function</IonCol>
                                <IonCol >Phone Number</IonCol>
                                <IonCol >Email Address</IonCol>
                                <IonCol >Employee Schema</IonCol>*/}
                                <IonCol >Action</IonCol>
                        </IonRow>
                        {viewEmployeeDetailsData.map((detailData) =>   {
                            return (
                                <IonRow class='gridResultBody'>
                                    <IonCol >{detailData.employeeID}</IonCol>
                                    <IonCol >{detailData.employeeFirstName + ' '+detailData.employeeLastName }</IonCol>
                                    <IonCol >{detailData.dateHired}</IonCol>
                                    {/*<IonCol >{detailData.biWeeklyPay}</IonCol>
                                    <IonCol >{detailData.jobFunction}</IonCol>
                                    <IonCol >{detailData.phoneNumber}</IonCol>
                                    <IonCol >{detailData.emailAddress}</IonCol>
                                    <IonCol >{detailData.employeeSchema}</IonCol>*/}
                                    <IonCol >
                                        <IonButton onClick={() => setShowPasswordModal(true)}> Delete Employee</IonButton>
                                        {showPasswordModal == true && <input type='text' id='enterPassword' ref={ enterPasswordRef }  placeholder='Enter Password' required></input>}
                                        {showPasswordModal == true && <IonButton onClick={() => deleteEmployee([detailData.globalEmployeeID, detailData.employeeID])}> Submit </IonButton>}

                                    </IonCol>
                                </IonRow>
                            )
                        }
                        )}
                    </IonGrid>
                    </div>

                    {/*{showPasswordModal == true && <EnterPasswordModal openModal={ showPasswordModal } closeModal={setShowPasswordModal(false)} onSubmitPassword={ (e) => onSubmitPasswordHandler(e) }></EnterPasswordModal>}*/}
        
            </IonContent>
            <IonFooter className='appFooter'>
                    <IonGrid>
                            <IonRow>
                                <IonCol size="12">
                                    <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}